module.exports = __webpack_public_path__ + "static/competicao-1-73e84b6c253bb9ab701187dcef1a2961.jpeg";